import React from 'react'
import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import PicCont from '../components/PicCont';
import SimilarCats from '../components/SimilarCats';
import BGBlock from '../components/BGBlock';
import ProductList from '../components/ProductList';
import { useDispatch, useSelector } from 'react-redux';
import { wrapper } from '../store/configStore';
import { SERVER_IP } from '../store/middleware/api';
import axios from 'axios';
import ClientReviews from '../components/ClientReviews';
import NotSure from '../components/NotSure';
import LandingCategories from '../components/LandingCategories';
import PastEvents from '../components/PastEvents';
import { getFilteredProducts, productsReceived, productsSetFilters } from '../store/slices/entities/products';
import { getAllPackages, packagesReceived } from '../store/slices/entities/packages';
import microphoneHeroV2 from '../public/Pictures/categories-v2/microphone-rental-hero-v2.jpg'
import microphones_a from '../public/Pictures/microphones-a.jpg'
import mictop from '../public/Pictures/mictop.jpg'
import { GiBigDiamondRing } from "@react-icons/all-files/gi/GiBigDiamondRing";
import { BsFillBriefcaseFill } from "@react-icons/all-files/bs/BsFillBriefcaseFill";
import { FaBirthdayCake } from "@react-icons/all-files/fa/FaBirthdayCake";
import { FaPersonBooth } from "@react-icons/all-files/fa/FaPersonBooth";
import { FaMicrophoneAlt } from "@react-icons/all-files/fa/FaMicrophoneAlt";
import { FaChalkboard } from "@react-icons/all-files/fa/FaChalkboard";
import { FaTheaterMasks } from "@react-icons/all-files/fa/FaTheaterMasks";
import { FaFootballBall } from "@react-icons/all-files/fa/FaFootballBall";
import { HiUserGroup } from "@react-icons/all-files/hi/HiUserGroup";
import { RiLandscapeLine } from "@react-icons/all-files/ri/RiLandscapeLine";
import { FaGlassMartiniAlt } from "@react-icons/all-files/fa/FaGlassMartiniAlt";
import { GiPartyFlags } from "@react-icons/all-files/gi/GiPartyFlags";
import { FaStar } from '@react-icons/all-files/fa/FaStar';
import UiBoundary from '../components/design-system/foundations/UiBoundary';
import ServiceHero from '../components/design-system/marketing/ServiceHero';
import AudioClosingActionBand from '../components/design-system/marketing/AudioClosingActionBand';
import ServiceOverview from '../components/design-system/marketing/ServiceOverview';
import RentalFAQV2 from '../components/design-system/marketing/RentalFAQV2';
import QuotePop from '../components/DeferredQuotePopup';
import { SHOW_POPUP } from '../store/slices/ui';
import { FiMessageCircle } from '@react-icons/all-files/fi/FiMessageCircle';
import { FiShoppingBag } from '@react-icons/all-files/fi/FiShoppingBag';
import * as gtag from '../lib/gtag';
import { compactCatalogProducts } from '../utilities/catalogPublicPayload';
import { compactPublicEvents } from '../utilities/eventPublicPayload';
import { getAudioFamilyBreadcrumbs, toBreadcrumbJsonLdItems, toHeroBreadcrumbs } from '../utilities/audioFamilyBreadcrumbs';
import MarketCoverageNotice from '../components/design-system/marketing/MarketCoverageNotice';

const sharedCatalogCoverage = {
    ariaLabel: 'Miami and Orlando catalog information',
    heading: 'Two Florida storefronts',
    body: 'Your selected Miami or Orlando store determines the inventory, pickup, delivery and availability shown on this shared equipment page.',
    cta: false
}

const microphoneOverviewContent = {
    id: 'microphone-rental-overview',
    heading: 'Rent microphones for meetings, performances and events',
    body: [
        'Discover our competitively priced range of Wired Microphones, Wireless Systems, Lapel, Handheld Microphones and more. Elevate your event\'s audio experience effortlessly with our premium, budget-friendly microphone rentals.',
        'Quickly select rental dates, receive an instant quote, and securely complete your microphone rental online in just a few clicks.'
    ],
    guide: {
        heading: 'Find the ideal microphone for your event',
        summary: <>Our range of <a href='#wired'>professional wired microphones</a> and <a href='#wireless'>wireless systems</a> is designed to meet any event requirement, from conferences to concerts.</>,
        body: [
            <p key='filters'>Tailor your selection by choosing <strong>Number of Microphones</strong>, <strong>Sound Quality</strong>, <strong>Price</strong>, and more.</p>,
            <p key='process'>Once you&apos;ve made your choice, select <strong>&quot;Choose Dates &amp; Rent Online&quot;</strong>. You can then choose warehouse pickup or delivery and setup before entering the dates needed to show real availability.</p>
        ]
    },
    media: { src: mictop, alt: '' }
}

const microphoneTypesContent = {
    id: 'microphone-rental-types',
    heading: 'Events for which microphones are Rented',
    body: (
        <ul>
            <li>Concerts</li><li>Music Festivals</li><li>Corporate Events</li><li>Conferences</li>
            <li>Sporting Events</li><li>Weddings</li><li>DJ Sets and Club Events</li><li>Birthday Parties</li>
        </ul>
    ),
    guide: {
        heading: 'Types of Microphones',
        summary: 'We offer several types of microphones commonly used for events, each serving a specific purpose:',
        body: (
            <ul>
                <li><strong>Handheld Microphones: </strong>These mics are held by the speaker or performer and are ideal for dynamic presentations.</li>
                <li><strong>Lavalier or Lapel Microphones: </strong>Lavalier mics are small, clip-on mics that can be attached to clothing.</li>
                <li><strong>Wireless Microphones: </strong>Wireless mics offer the flexibility to move around the stage.</li>
                <li><strong>Headset Microphones: </strong>Wireless mics are ideal for public speaking, presentations, and performances.</li>
            </ul>
        )
    },
    media: { src: microphones_a, alt: '' }
}


export const getStaticProps = wrapper.getStaticProps(
    async ({ store, preview }) => {
        const corp = await axios.request(`${SERVER_IP}/user/static-landing`)
        const subCate = await axios.request(`${SERVER_IP}/subcategory/name/microphones?cat=sound`)
        const products = await axios.request(`${SERVER_IP}/inventory/product?msr=true&cat=microphones`)
            const faq = await axios.request(`${SERVER_IP}/faq?category=Microphone`)
        store.dispatch({ type: productsReceived.type, payload: compactCatalogProducts(products.data) })
        store.dispatch({ type: productsSetFilters.type, payload: { static: true } })
        let { newsletterevents, total_events } = corp?.data
        return {
            props: {
                newsletterevents: compactPublicEvents(newsletterevents), total_events, subCate: subCate.data, faq: faq.data
            }
        }
    }
);

const TVRental = ({ newsletterevents, total_events, subCate, faq }) => {
    let products = useSelector(getFilteredProducts)
    let packages = useSelector(getAllPackages)
    const dispatch = useDispatch()
    const openQuote = () => {
        gtag.event({ action: 'quote_click', label: 'leads', value: 3, category: 'orders' })
        dispatch(SHOW_POPUP({
            key: 'quote',
            size: 'medium',
            body: <QuotePop />
        }))
    }
    const heroSteps = [
        { icon: 'search', title: 'Choose your microphone', description: 'Compare handheld, lapel, and headset options.' },
        { icon: 'calendar', title: 'Select dates', description: 'Tell us when you need it.' },
        { icon: 'truck', title: 'Pickup or delivery', description: 'Collect it or schedule professional delivery.' },
        { icon: 'success', title: 'Event-ready audio', description: 'Reliable microphones with local support.' }
    ]
    const primaryHeroAction = {
        label: 'Browse Microphones',
        href: '#wireless',
        icon: FiShoppingBag,
        conversionKey: 'microphone-rental.hero.browse-microphones',
        channel: 'rental',
        salesPath: 'self_service',
        onClick: () => gtag.event({
            action: 'catalog_click',
            label: 'leads',
            value: 2,
            category: 'orders'
        })
    }
    const secondaryHeroAction = {
        label: 'Talk to an Expert',
        icon: FiMessageCircle,
        conversionKey: 'microphone-rental.hero.talk-to-expert',
        channel: 'quote',
        salesPath: 'managed',
        onClick: openQuote
    }
    const breadcrumbs = getAudioFamilyBreadcrumbs('/microphone-rental')
    return <>
        <BreadcrumbJsonLd
        itemListElements={toBreadcrumbJsonLdItems(breadcrumbs)}
      />
        <NextSeo
            title='Microphone Rental in Florida | Miami & Orlando'
            description='Rent wireless, handheld, lavalier, lapel and headset microphones from our Miami or Orlando store. Compare equipment, dates, pickup and delivery options online.'
            canonical="https://miamisoundrental.com/microphone-rental"
            twitter={{
                handle: '@miamisoundrent1',
                site: '@miamisoundrent1',
                cardType: 'summary_large_image',
            }}
            openGraph={{
                type: 'website',
                url: `https://miamisoundrental.com/microphone-rental`,
                title: 'Microphone Rental in Florida | Miami & Orlando',
                description: 'Rent wireless, handheld, lavalier, lapel and headset microphones from our Miami or Orlando store. Compare equipment, dates, pickup and delivery options online.',
                images: [
                    {
                        url: 'https://dnw-server.s3.us-east-2.amazonaws.com/microphones_og.jpg',
                        width: 800,
                        height: 600,
                        alt: 'Miami Sound Rental',
                    },

                ],
                site_name: 'Miami Sound Rental',
            }}
        />
        <UiBoundary className='categoryRental projectorRental'>
            <ServiceHero
                breadcrumbs={toHeroBreadcrumbs(breadcrumbs)}
                eyebrow='Professional microphone rental · Miami & Orlando'
                title='Microphone Rental'
                description='Compare professional wireless, handheld, lapel and headset microphones online. Inventory, pickup and delivery options update for your selected Miami or Orlando store.'
                image={{ src: microphoneHeroV2, position: 'center' }}
                imageAlt='Shure wireless handheld microphones charging at a Miami Sound Rental event'
                primaryAction={primaryHeroAction}
                secondaryAction={secondaryHeroAction}
                processLabel='How microphone rental works'
                steps={heroSteps}
            />

            <MarketCoverageNotice content={sharedCatalogCoverage} />

            <ServiceOverview content={microphoneOverviewContent} />

				{/* <div className="stageTypes">
                <h2 className='upper'>Select the perfect Microphone Rental for your next event</h2>
                <span className='underUpper'>In our Microphone rental section, you can find our full selection of microphones: wireless microphone sets with handheld and lapel microphones, ideal for conferences and presentations; Vocal microphones for live performances and instrument and drum microphones.

If you want to rent a microphone and speaker, please go to the mic and speaker rental section, where you can find premade microphone and speaker bundles.</span>
            </div> */}
            <section className='stageType white'>
                {/* <div className="typeHeader">
                    <div className="row">
                        <div className="col">
                            <div className='upper'>Different types of Microphones</div>
                            <p>
                                We offer several types of microphones commonly used for events, each serving a specific purpose:
                                <ul>
                                    <li><strong>Handheld Microphones: </strong>These mics are held by the speaker or performer and are ideal for dynamic presentations, live performances, or situations where mobility and control are essential.</li>
                                    <li><strong>Lavalier or Lapel Microphones: </strong>Lavalier mics are small, clip-on mics that can be attached to clothing, providing hands-free operation and discreet amplification.</li>
                                    <li><strong>Wireless Microphones: </strong>Wireless mics offer the flexibility to move around the stage or venue without being tethered by cables.</li>
                                    <li><strong>Headset Microphones: </strong>Wireless mics are ideal for public speaking, presentations, performances, broadcasting, and more.</li>
                                </ul>
                            </p>
                        </div>
                        <PicCont src={microphones_a} />
                    </div>
                </div> */}
                        <div id='wireless'> </div>
                <ProductList
                    carousel={{
                    name: 'Microphone Rentals',
                    url: 'https://miamisoundrental.com/microphone-rental',
                    description: 'Microphone rental list'
                }}
                ui='v2' sortBy={{
    'Sound Quality': ['darkGoldenRod', <FaStar key='quality' style={{color: 'darkGoldenRod'}}  />],
    'Microphones': ['darkSlateBlue', <FaMicrophoneAlt key='group' style={{color: 'darkSlateBlue'}}  />],
    }}  listName='Wireless Microphones' anchor products={products.filter(p => p.categories?.includes('Sound/Microphones') && p.tags.includes('wireless'))} />
           <NotSure ui='v2' />
            </section>
            <section className='stageType'>
            <LandingCategories ui='v2' loading='lazy' options category='sound' className='padTop' heading='Explore other AV Categories' />
            <div id='wired'> </div>
            <ProductList ui='v2' noTop sortBy={{
    'Mic Type': ['green', <FaMicrophoneAlt key='group' style={{color: 'green'}}  />],
    }}  listName='Wired Microphones' products={products.filter(p => p.categories?.includes('Sound/Microphones') && !p.tags.includes('wireless') && !p.tags.includes('accessory'))} />
            </section>

            <ServiceOverview content={microphoneTypesContent} />
           <RentalFAQV2 questions={faq} headingId='microphone-rental-faq-title' />
            <section className='stageType'>

            <ProductList ui='v2' noTop sortBy={{
    'Sound Quality': ['darkGoldenRod', <FaStar key='quality' style={{color: 'darkGoldenRod'}}  />],
    'Microphones': ['darkSlateBlue', <FaMicrophoneAlt key='group' style={{color: 'darkSlateBlue'}}  />],
    }}  listName='Microphone Accessories' products={products.filter(p => p.categories?.includes('Sound/Microphones') && p.tags.includes('accessory'))} />
            </section>
            <SimilarCats
                ui='v2'
                subCate={subCate}
                additionalServices={[{
                    h1: 'Complete Sound System & PA Rental',
                    url: '/sound-system-rental',
                    miniText: 'Choose a complete PA system with microphones, mixer, delivery, setup, and audio support.'
                }]}
            />
    
            <PastEvents ui='v2' filter={['corporate', 'conference']} newsletterevents={newsletterevents} total_events={total_events} />
            <ClientReviews
                ui='v2'
                filter={['microphone']}
                heading='Feedback relevant to microphone rentals and event audio'
            />
            <AudioClosingActionBand
                pagePath='/microphone-rental'
                primaryAction={primaryHeroAction}
                secondaryAction={secondaryHeroAction}
            />
        </UiBoundary>
    </>
}

export default TVRental
